<template>
  <div class="comp-list-placeholder">
    <img :src="'//pic2.iqiyipic.com/kppfe/static/icon/20191128/img_' + icon + '.png'" class="icon" alt=""/>
    <template v-if="login">
      <div class="title">{{title}}</div>
      <div class="desc" v-if="desc">{{desc}}</div>
<!--      <div v-if="showBtn" class="btn-enter" @click="onClick">{{btn}}</div>-->
    </template>
    <template v-else>
      <div class="title">登录后可查看内容</div>
      <div class="desc" v-if="desc">知识是心灵的活动</div>
      <div class="btn-enter" @click="onLogin">登录</div>
    </template>
  </div>
</template>

<script>
  import passport from '@iqiyi-kpp/passport'
  export default {

    props: {
      // 是否登录
      login: {
        type: Boolean,
        default: true,
      },
      // 小图标： cart, play, folder, 404, login, list
      icon: {
        type: String,
        default: 'list',
      },
      title: {
        type: String
      },
      desc: {
        type: String
      },
      btn: {
        type: String,
        default: '去看看'
      },
      tap: {
        type: Function
      },
      showBtn: {
        type: Boolean,
        default: true
      }
    },

    methods: {
      onClick() {
        if (this.tap) {
          this.tap()
        }
      },

      onLogin() {
        passport.login()
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../assets/css/var";
  @import "../assets/css/func";

  .comp-list-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    line-height: normal;
    .icon {
      .set(width, 180);
      .set(height, 180);
      .set(margin-top, 210);
    }

    .title {
      color: #999999;
      .set(margin-top, 24);
      .set(font-size, 28);
    }

    .desc {
      color: #B5B5B5;
      .set(font-size, 24);
      .set(margin-top, 32);
    }

    .btn-enter {
      color: @color-brand;
      border: 1px solid @color-brand;
      .set(font-size, 22);
      .set(margin-top, 60);
      .set(border-radius, 100);
      .set(padding-left, 32);
      .set(padding-right, 32);
      .set(padding-top, 11);
      .set(padding-bottom, 11);
    }
  }
</style>
